var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthKoriya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 15H10V35H40V15Z",
    fill: "#D9DBDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1914 31.0955L31.9141 33.0117L32.6271 33.487L33.9045 31.5708L33.1914 31.0955Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1368 30.4197L30.8594 32.3359L31.5724 32.8112L32.8498 30.895L32.1368 30.4197Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1055 29.7049L29.8281 31.6211L30.5411 32.0964L31.8185 30.1802L31.1055 29.7049Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7071 28.8494L33.4297 30.7656L34.1427 31.2409L35.4201 29.3247L34.7071 28.8494Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6446 28.1736L32.3672 30.0898L33.0802 30.5651L34.3576 28.6489L33.6446 28.1736Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6211 27.4588L31.3438 29.375L32.0568 29.8503L33.3342 27.9341L32.6211 27.4588Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3302 27.4427L16.6172 27.918L19.4096 32.1069L20.1226 31.6316L17.3302 27.4427Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7521 30.3958L17.0391 30.8711L18.3164 32.7873L19.0295 32.312L17.7521 30.3958Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2599 28.1419L15.5469 28.6172L16.8243 30.5334L17.5373 30.0581L16.2599 28.1419Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2443 28.8372L14.5312 29.3125L17.3237 33.5015L18.0367 33.0262L15.2443 28.8372Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1505 19.5052L33.4375 19.9805L34.7149 21.8967L35.4279 21.4214L34.1505 19.5052Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6115 17.2786L31.8984 17.7539L33.1758 19.6701L33.8888 19.1948L32.6115 17.2786Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5646 17.927L30.8516 18.4023L33.644 22.5913L34.357 22.116L31.5646 17.927Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0646 20.8958L31.3516 21.3711L32.6289 23.2873L33.342 22.812L32.0646 20.8958Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5411 18.595L29.8281 19.0703L31.1055 20.9865L31.8185 20.5112L30.5411 18.595Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 18.604L16.5938 22.793L17.3068 23.2683L20.0992 19.0793L19.3862 18.604Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3315 17.936L15.5391 22.125L16.2521 22.6003L19.0445 18.4113L18.3315 17.936Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3002 17.2134L14.5078 21.4023L15.2208 21.8777L18.0133 17.6887L17.3002 17.2134Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7712 22.5625C19.218 24.8655 19.8607 27.9718 22.1637 29.525C24.4666 31.0781 27.573 30.4354 29.1261 28.1325C29.8759 26.9542 29.6081 25.401 28.4299 24.6512C27.2516 23.9014 25.6985 24.1692 24.9487 25.3475C24.1988 26.5257 22.6457 26.7935 21.4674 26.0437C20.3427 25.2939 20.0214 23.7408 20.7712 22.5625Z",
    fill: "#003478"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7714 22.5621C20.0216 23.7404 20.2894 25.2935 21.4677 26.0433C22.646 26.7931 24.1991 26.5253 24.9489 25.3471C25.6987 24.1688 27.2519 23.901 28.4301 24.6508C29.6084 25.4006 29.8762 26.9538 29.1264 28.1321C30.6796 25.8291 30.0369 22.7228 27.7339 21.1696C25.4309 19.6165 22.3246 20.2591 20.7714 22.5621Z",
    fill: "#C60C30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKoriya);
export default __webpack_public_path__ + "static/media/south-koriya.ce8307e88e61123d7d9e7dd83e8c63e9.svg";
export { ForwardRef as ReactComponent };